import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './key-pickups-manager.scss';

const CARD_COUNT: number = 8;

const KeyPickupsManagerSkeleton = () => (
  <div className="key-pickups-manager" aria-hidden>
    <Skeleton variant="text" width="28rem" />
    <Skeleton variant="text" width="44rem" />
    <div className="property-card-grid">
      {Array.from({ length: CARD_COUNT }, (_, index: number) => (
        <Skeleton
          key={`kp-skeleton-card-${index}`}
          variant="rect"
          width="100%"
          height="12rem"
        />
      ))}
    </div>
  </div>
);

export default KeyPickupsManagerSkeleton;